import { StatusLight, Text } from '@react-spectrum/s2';
import { style } from '@react-spectrum/s2/style' with { type: 'macro' };
import type { Moment } from 'moment';

import type { EffectiveStatus } from '@/hooks/useContentArtifacts';
import type { SchedulePublishState } from '@/spaces/chat/panels/scheduleUtils';

import { formatSendDate } from './emailSendDate';
import { getStatusLabel, getStatusVariant } from './statusVisuals';

interface TileFooterProps {
	status: EffectiveStatus;
	date: Moment | null;
	publishState?: SchedulePublishState;
}

const bodyTextStyle = style({
	font: 'body',
	fontSize: 'body-xs',
	color: 'body',
});

export const TileFooter = ({ status, date, publishState }: TileFooterProps) => {
	return (
		<div className="flex flex-wrap items-center gap-2">
			<StatusLight variant={getStatusVariant(status, publishState)}>
				<Text styles={bodyTextStyle}>
					{getStatusLabel(status, publishState)}
				</Text>
			</StatusLight>
			{date && (
				<>
					<Text styles={bodyTextStyle}>|</Text>
					<Text styles={bodyTextStyle}>{formatSendDate(date)}</Text>
				</>
			)}
		</div>
	);
};
